import { useQuery } from '@tanstack/react-query'

interface NameField {
  name: string;
}

interface MapboxSearchContext {
  country: NameField & { country_code: string };
  region: NameField & { region_code: string };
  postcode: NameField;
  district: NameField;
  place: NameField;
  neighborhood: NameField;
  address: NameField;
  street: NameField;
}

interface MapboxSearchSuggestion {
  name: string;
  address: string;
  full_address: string;
  place_formatted: string;
  context: MapboxSearchContext;
}

interface MapboxSearchResponse {
  suggestions: MapboxSearchSuggestion[];
}

interface MapboxSearchError {
  message: string;
  status: number;
}

export function useMapboxSearch ({
  query,
  accessToken,
  sessionToken,
  enabled = true,
}: {
  query: string | undefined;
  accessToken: string;
  sessionToken: string;
  enabled?: boolean;
}) {
  return useQuery<MapboxSearchResponse, MapboxSearchError>({
    queryKey: ['mapbox-search', query],
    queryFn: async () => {
      if (!query) {
        return { suggestions: [] }
      }

      // TODO: add future eslint-disable-next-line for bare fetch
      const response = await fetch(
        `https://api.mapbox.com/search/searchbox/v1/suggest?q=${encodeURIComponent(
          query
        )}&access_token=${accessToken}&session_token=${sessionToken}&language=en&country=US&limit=10&types=address`
      )

      if (!response.ok) {
        const errorJson = await response.json()
        throw new Error(
          errorJson.message || 'Failed to fetch address suggestions.'
        )
      }

      return response.json()
    },
    enabled: enabled && !!query && query.length > 2,
    retry: false,
  })
}
